import { useAuthStore } from "../../stores/authStore";

export function hasPermission(permission?: string | null) {
  if (!permission) return true;
  const { user } = useAuthStore.getState();
  const roles = user?.roles.map((x) => x.toLowerCase()) ?? [];
  if (roles.some((x) => x === "admin" || x === "administrator" || x === "superadmin")) return true;
  const perms = user?.permissions.map((x) => x.toLowerCase()) ?? [];
  return perms.includes(permission.toLowerCase());
}
